import { STATUS_STEPS } from '~/types/orders.ts';
import { useTranslation } from 'react-i18next';
import { hasReachedStatus } from '~/utils';
import type { OrderStatus } from '~/graphql/graphql';

export function OrderStatusProgress({
  status,
}: {
  status: Exclude<OrderStatus, 'DRAFT' | 'CANCELLED' | 'BLOCKED'>;
}) {
  const { t } = useTranslation('order');

  return (
    <div className="flex items-center justify-between mb-6">
      {STATUS_STEPS.map(({ status: stepStatus, label, Icon }) => {
        const isComplete = hasReachedStatus(status, stepStatus);

        return (
          <div key={stepStatus} className="flex-1 flex items-center">
            <div className="flex flex-col items-center flex-1">
              <div
                className={
                  'w-10 h-10 rounded-full flex items-center justify-center mb-2 text-white ' +
                  (isComplete ? 'bg-prim' : 'bg-gray-100')
                }
              >
                <Icon size={20} />
              </div>
              <p
                className={
                  'text-xs font-medium text-center ' +
                  (isComplete ? 'text-prim' : 'text-gray-400')
                }
              >
                {t(label)}
              </p>
            </div>
            {stepStatus !== 'DELIVERED' && (
              <div
                className={
                  'flex-1 h-0.5 mx-2 ' +
                  (isComplete ? 'bg-prim' : 'bg-gray-100')
                }
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
